import { useState, useEffect, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import classNames from 'classnames'

import { setCurrentTab, showSideBar, showNavBar } from '../../actions/commonActions'
import { getCoaches, inviteCoach } from '../../actions/coachActions'
import { START_PAGE_DEFAULT, PER_PAGE_DEFAULT } from '../../misc/Constants'

import Loader from '../common/loader/legacy-loaders/Op36Loader-web'
import InviteCoachModal from './InviteCoachModal'
import PageHeader from '../common/PageHeader/PageHeader'
import CoachesHeader from './CoachesHeader'
import CoachesTable from './CoachesTable'

import classes from './CoachesPage.module.scss'

const CoachesPage = () => {
  const dispatch = useDispatch()
  const coaches = useSelector(state => state.coaches)

  const [searchTerm, setSearchTerm] = useState('')
  const [coachLoader, setCoachLoader] = useState(true)
  const [isSearching, setIsSearching] = useState(false)
  const [currentPage, setCurrentPage] = useState(START_PAGE_DEFAULT)
  const [statusFilter, setStatusFilter] = useState('all')
  const [showInviteCoachModal, setShowInviteCoachModal] = useState(false)

  const coachList = coaches.coaches || []
  const coachCount = coaches.pagination?.total_count || coachList.length
  const hasMore = coaches.pagination ? currentPage < coaches.pagination.total_pages : false

  const fetchCoachesData = useCallback(({ page = START_PAGE_DEFAULT, append = false, search, filter }) => {
    setCurrentPage(page)
    const searchQuery = search !== undefined ? search : searchTerm
    const statusQuery = filter !== undefined ? (filter === 'all' ? null : filter) : (statusFilter === 'all' ? null : statusFilter)

    dispatch(getCoaches(searchQuery, page, PER_PAGE_DEFAULT, statusQuery, append)).finally(() => {
      setCoachLoader(false)
      setIsSearching(false)
    })
  }, [dispatch, searchTerm, statusFilter])

  useEffect(() => {
    dispatch(setCurrentTab('Coaches'))
    dispatch(showSideBar(true))
    dispatch(showNavBar(true))

    fetchCoachesData({})
  }, [dispatch, fetchCoachesData])

  const handleSearchChange = (search) => {
    setSearchTerm(search)
    setIsSearching(true)

    fetchCoachesData({ search })
  }

  const handleFilterChange = (filter) => {
    setStatusFilter(filter)
    setIsSearching(true)

    fetchCoachesData({ filter })
  }

  const fetchMoreCoaches = () => {
    fetchCoachesData({ page: currentPage + 1, append: true })
  }

  const handleInviteCoach = (inviteData) => (
    dispatch(inviteCoach(inviteData))
      .then(() => {
        setShowInviteCoachModal(false)
        toast.success('Coach invitation sent successfully', { position: toast.POSITION.TOP_RIGHT })
      })
      .catch((error) => {
        const errorMessage = error.response.data.errors[Object.keys(error.response.data.errors)[0]][0] ?? 'Something went wrong'
        toast.error(errorMessage, { position: toast.POSITION.TOP_RIGHT })
      })
  )

  const inviteCoachButton = (
    <button className='btn btn-primary text-white pull-right mr-2' onClick={() => setShowInviteCoachModal(true)}>
      Invite Coach
    </button>
  )
  3
  return (
    <div>
      <PageHeader title='Coaches' actionComponent={inviteCoachButton} />

      <main className={classNames(classes.coachesContent, 'w-100')}>
        <CoachesHeader
          coachCount={coachCount}
          isSearching={isSearching}
          statusFilter={statusFilter}
          onSearchChange={handleSearchChange}
          onFilterChange={handleFilterChange}
        />

        {coachLoader ? (
          <Loader message={'Loading Coaches'} />
        ) : (
          <CoachesTable
            coachList={coachList}
            hasMore={hasMore}
            onFetchMore={fetchMoreCoaches}
          />
        )}
      </main>

      {showInviteCoachModal && (
        <InviteCoachModal
          isOpen={showInviteCoachModal}
          onClose={() => setShowInviteCoachModal(false)}
          onSubmit={handleInviteCoach}
        />
      )}
    </div>
  )
}

export default CoachesPage
